import { StaticCard } from "shared/components/Spor";
import { FC, useContext, useMemo } from "react";
import {
  PlanEventInformation,
  PlanMeasureKey,
} from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/types";
import { ColumnHeader } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/ColumnHeader";
import { MeasureOverviewContext } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewContext";

type MeasureOverviewColumnHeaderProps = {
  measureKey: PlanMeasureKey;
  infraMeasures: PlanEventInformation[] | undefined;
  trainMeasures: PlanEventInformation[] | undefined;
};

export const MeasureOverviewColumnHeader: FC<
  MeasureOverviewColumnHeaderProps
> = ({ measureKey, trainMeasures, infraMeasures }) => {
  const { showClosed } = useContext(MeasureOverviewContext);

  const infraMeasuresToShow = useMemo(
    () =>
      showClosed
        ? infraMeasures
        : infraMeasures?.filter((m) => m.information.state !== "CLOSED"),
    [showClosed, infraMeasures],
  );

  const trainMeasuresToShow = useMemo(
    () =>
      showClosed
        ? trainMeasures
        : trainMeasures?.filter((m) => m.information.state !== "CLOSED"),
    [showClosed, trainMeasures],
  );

  const totalCount =
    (infraMeasuresToShow?.length ?? 0) + (trainMeasuresToShow?.length ?? 0);

  return (
    <StaticCard
      borderTopRadius="xs"
      borderBottomRadius={0}
      backgroundColor="semantics.colorBackgroundSecondary"
    >
      <ColumnHeader measureKey={measureKey} totalCount={totalCount} />
    </StaticCard>
  );
};
